// useScreenSize.ts
import { useEffect, useState } from 'react';

export const breakpoints = {
  xs: 0,
  sm: 640,
  md: 768,
  lg: 1024,
  xl: 1280,
};

export const useScreenSize = () => {
  // Initialize with actual width when available so first render (and first data fetches)
  // use correct mobile/tablet detection on real devices. Avoids width=0 → wrong 30-day fetch.
  const [width, setWidth] = useState<number>(() =>
    typeof window !== 'undefined' ? window.innerWidth : 0
  );

  useEffect(() => {
    const updateSize = () => setWidth(window.innerWidth);

    updateSize(); // sync with current size after mount (handles resize, orientation, etc.)
    window.addEventListener('resize', updateSize);

    return () => window.removeEventListener('resize', updateSize);
  }, []);

  const isMobile = width < breakpoints.sm;
  const isTablet = width >= breakpoints.sm && width < breakpoints.md;
  const isDesktop = width >= breakpoints.lg;

  return {
    width,
    isMobile,
    isTablet,
    isDesktop,
    xs: width < breakpoints.sm,
    sm: width >= breakpoints.sm && width < breakpoints.md,
    md: width >= breakpoints.md && width < breakpoints.lg,
    lg: width >= breakpoints.lg && width < breakpoints.xl,
    xl: width >= breakpoints.xl,
  };
};
